//import $ from 'imports/jquery'
import { gsap, CSSPlugin, ScrollToPlugin } from 'imports/gsap/all'
import { Power4 } from 'imports/gsap'
gsap.registerPlugin(ScrollToPlugin);
let global = {
    init: function () {
        $('.jump').on('click',global.jump)
    },
    ////////////////////////////////////////////////////////////////////////////////////

    jump: function() {
        let tid = '#' + $(this).attr('data-jump')
        gsap.to(window, {duration: 0.75, ease: Power4.easeInOut, scrollTo: {y: tid, offsetY: 70}});
    },


}
export default global
